import React from 'react';
import NewsBanner from './NewsBanner';
import NewsHeader from './NewsHeader';
import NewsBody from './NewsBody';
import CompanyTag from './CompanyTag';
import { useNewsCardData } from './useNewsCardData';
import { useNewsCardClick } from './useNewsCardClick';
import { buttonResetStyles } from './newsCardStyles';
import type { BaseNewsCardProps } from './types';

const CompactNewsCard: React.FC<BaseNewsCardProps> = ({
  newsItem,
  onClick,
  showCompanies = true,
  showSource = true,
  showTimestamp = true,
  className = '',
  aemImages,
  timestampLabels,
  componentPosition,
}) => {
  const data = useNewsCardData(newsItem, aemImages);
  const { handleClick } = useNewsCardClick({
    newsId: newsItem.id,
    onClick,
    newsType: "otherNews",
    newsHeading: data.title,
    componentPosition: componentPosition ?? newsItem.id.toString(),
  });

  return (
    <button
      onClick={handleClick}
      aria-label={`View news: ${data.title}`}
      className={`flex gap-4 min-w-[320px] min-h-[106] md:w-[860px] md:min-h-[102px] bg-white border border-[#E5E5E5] rounded p-3 md:px-4 md:py-3 items-center cursor-pointer transition-colors ${className}`}
      style={{ ...buttonResetStyles }}
    >
      <NewsBanner
        bannerLink={data.bannerLink}
        title={data.title}
        className="w-[60px] h-[60px] md:w-[72px] md:h-[72px] object-cover rounded shrink-0"
        aemImages={aemImages}
      />
      <div className="flex-1">
        <NewsBody title={data.title} titleClassName="mb-3" />
        <div className="flex items-center gap-2 text-xs">
          {showCompanies && data.companies && data.companies.length > 0 && data.companies[0]?.percentage != null && (
            <CompanyTag company={data.companies[0]} />
          )}
          <NewsHeader
            sourceName={showSource ? data.sourceName : undefined}
            sourceLogo={showSource ? data.sourceLogo : undefined}
            timestamp={showTimestamp ? data.timestamp : undefined}
            aemImages={aemImages}
            timestampLabels={timestampLabels}
          />
        </div>
      </div>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="text-black shrink-0 hidden md:block"
        aria-hidden="true"
      >
        <path
          d="M12 8L20 16L12 24"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default CompactNewsCard;

